<template>
  <section class="ruejai-club-banner-editor">
    <div class="image-uploader">
      <img class="image img-fluid mb-4" :src="thumbnailUrl" />
      <sc-button
        class="w-100"
        @click="handleClickChooseImageButton"
      >อัพโหลดรูปภาพ</sc-button>
    </div>
    <div class="detail">
      <div class="mb-4">
        <div class="label">ชื่อ</div>
        <el-input v-model="title"></el-input>
      </div>
      <div class="mb-4">
        <div class="label">package</div>
        <el-select
          v-model="ruejaiClubPackageId"
          value-key="id"
          class="w-100"
          filterable
          clearable
          remote
        >
          <el-option
            v-for="item in packages"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImageDialog"
      @confirm="handleConfirmChooseImageDialog"
    ></image-picker-modal>
  </section>
</template>

<script>
import { Input, Select, Option } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import DatePicker from "@/lib/components/DatePicker";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    ScButton,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    DatePicker,
    ImagePickerModal
  },
  props: ["value", "disabled", "imageUrl"],
  data() {
    return {
      isShowModal: false,
      fileThumbnailUrl: null,
      packages: []
    };
  },
  watch: {
    value(val, oldVal) {
      if (val.imageFile === oldVal.imageFile) {
        return;
      }

      this.fileThumbnailUrl = URL.createObjectURL(val.imageFile);
    }
  },
  computed: {
    chooseImageDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: !this.disabled,
        title: "เลือกรูป",
        width: 300,
        height: 200,
        recommendWidth: 1200,
        recommendHeight: 800,
        thumbnailFile: this.value.imageFile,
        thumbnailUrl: this.thumbnailUrl
      };
    },
    thumbnailUrl() {
      return (
        this.fileThumbnailUrl ||
        this.imageUrl ||
        "https://placehold.co/1200x800"
      );
    },
    title: {
      get() {
        return this.value.title;
      },
      set(title) {
        this.$emit("input", { ...this.value, title });
      }
    },
    ruejaiClubPackageId: {
      get() {
        return this.value.ruejaiClubPackageId;
      },
      set(ruejaiClubPackageId) {
        this.$emit("input", { ...this.value, ruejaiClubPackageId });
      }
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupPackages();
    },
    async setupPackages() {
      const result = await this.fetchPackages();

      this.packages = result;
    },
    async fetchPackages() {
      // TODO: change to infinite loading for pagination package
      const params = { page_size: 500 };

      const response = await baanRueJaiClient.admin.ruejaiClub.packages.list(params);

      return response.data.result.items;
    },
    handleCancelChooseImageDialog() {
      this.isShowModal = false;
    },
    handleConfirmChooseImageDialog(file) {
      this.$emit("input", { ...this.value, imageFile: file });
      this.isShowModal = false;
    },
    handleClickChooseImageButton() {
      this.isShowModal = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.ruejai-club-banner-editor {
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 350px 1fr;

  .image {
    border: $border;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/banner/components/RuejaiClubBannerEditor.vue